
import { createSlice } from '@reduxjs/toolkit';
import {
  AuthState,
  AuthSetUserAction,
  AuthSetUserRoleAction,
} from './auth.types';
import { createSelector, createSliceHook, makeActionCreator } from '../helpers';
import { RootStateWithInjection } from '@restore/store';

const initialState: AuthState = {
  data: undefined,
};

const { actReq, actResolve } = makeActionCreator<AuthState>();

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  selectors:{
    getUser: state => state.data,
  },
  reducers: {
    setUser: actReq<AuthSetUserAction['payload']>(null),
    setUserDone: actResolve<AuthSetUserAction['payload']>('data', null, null),
    setUserRole: actReq<AuthSetUserRoleAction['payload']>(),
    setUserRoleDone: actResolve<AuthSetUserAction['payload']>('data', null, null),
    clearUser: state => {
      state.data = undefined;
    },
  },
});

export const { setUser, setUserDone, setUserRole, setUserRoleDone, clearUser } =
  authSlice.actions;

export const actions = {
  ...authSlice.actions,
};

export const useAuthSlice = createSliceHook(authSlice.name, actions);

export const selectAuthState = createSelector('auth');

export const selectAuthView = (state: RootStateWithInjection) => {
  const auth = selectAuthState(state);
  const user = auth.data;

  return {
    user,
    uuid: user?.['dynamika7/user_metadata']?.uuid ?? null,
    selectedRole: user?.selectedRole ?? null,
  };
};
